import { CommandProps, Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import { BlockTypes, VideoBlockDataItem } from '../../../../models';
import { PdfNodeView } from './PdfNodeView';

interface PdfProps {
  items: VideoBlockDataItem[];
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    pdfNode: { insertPdfNode: ({ items }: PdfProps) => ReturnType };
  }
}

export const PdfNode = Node.create({
  name: 'pdfNode',
  group: 'block',
  atom: true,

  addAttributes() {
    return { items: [], pastedFiles: [] };
  },

  parseHTML() {
    return [{ tag: BlockTypes.pdf }];
  },

  renderHTML({ HTMLAttributes }) {
    return [BlockTypes.pdf, mergeAttributes(HTMLAttributes)];
  },

  addCommands() {
    return {
      insertPdfNode:
        ({ items }: PdfProps) =>
        ({ commands }: CommandProps) => {
          return commands.insertContent({ type: this.name, attrs: { items } });
        },
    };
  },

  addNodeView() {
    return ReactNodeViewRenderer(PdfNodeView);
  },
});
